// import React from "react";

// export default function Poker6() {
//     return (
//         <div className="modal-dialog modal-xl">
//             <div className="modal-content">
//                 <div className="modal-header">
//                     <div className="modal-title h4">Result</div>
//                     <button type="button" className="btn-close" aria-label="Close" />
//                 </div>
//                 <div className="modal-body">
//                     <div className="casino-result-modal">
//                         <div className="casino-result-round-id">
//                             <span>
//                                 <b>Round Id: </b> 110250517143013
//                             </span>
//                             <span>
//                                 <b>Match Time: </b>17/05/2025 14:30:13
//                             </span>
//                         </div>
//                         <div className="row mt-2">
//                             <div className="col-md-12 text-center">
//                                 <h4 className="result-title">Board</h4>
//                                 <div className="casino-result-cards">
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/9HH.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/7DD.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/6SS.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/2HH.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/4CC.jpg" />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row mt-2">
//                             <div className="col-md-2" />
//                             <div className="col-md-4 text-center">
//                                 <h4 className="result-title">1</h4>
//                                 <div className="casino-result-cards">
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/KSS.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/AHH.jpg" />
//                                 </div>
//                             </div>
//                             <div className="col-md-4 text-center">
//                                 <h4 className="result-title">6</h4>
//                                 <div className="casino-result-cards">
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/10SS.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/3HH.jpg" />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row mt-2">
//                             <div className="col-md-1" />
//                             <div className="col-md-4 text-center">
//                                 <h4 className="result-title">2</h4>
//                                 <div className="casino-result-cards">
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/JDD.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/6HH.jpg" />
//                                 </div>
//                             </div>
//                             <div className="col-md-2" />
//                             <div className="col-md-4 text-center">
//                                 <h4 className="result-title">5</h4>
//                                 <div className="casino-result-cards">
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/5SS.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/9DD.jpg" />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row mt-2">
//                             <div className="col-md-2" />
//                             <div className="col-md-4 text-center">
//                                 <h4 className="result-title">3</h4>
//                                 <div className="casino-result-cards">
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/10HH.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/8DD.jpg" />
//                                     <div className="casino-winner-icon">
//                                         <i className="fas fa-trophy " />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-md-4 text-center">
//                                 <h4 className="result-title">4</h4>
//                                 <div className="casino-result-cards">
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/QCC.jpg" />
//                                     <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/5DD.jpg" />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row mt-2 justify-content-center">
//                             <div className="col-md-6">
//                                 <div className="casino-result-desc">
//                                     <div className="casino-result-desc-item">
//                                         <div>Winner</div>
//                                         <div>Player 3</div>
//                                     </div>
//                                     <div className="casino-result-desc-item">
//                                         <div>Pattern</div>
//                                         <div>Straight</div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>

//     );
// }

import React from "react";

export default function Poker6({ data }) {
  const casinoResult = data?.casinoIndividualResultDTO;

  if (!casinoResult) {
    return <div>No data available</div>;
  }

  // Helper function to get card images
  const getCardImage = (card) =>
    `https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/${card}.png`;

  return (
    <div className="modal-body">
      <div className="casino-result-modal">
        {/* Round ID and Match Time */}
        <div className="casino-result-round-id">
          <span>
            <b>Round Id: </b> {casinoResult.marketId}
          </span>
          <span>
            <b>Match Time: </b>{" "}
            {new Date(casinoResult.createdAt + "Z").toLocaleString()}
          </span>
        </div>

        {/* Player and Board Cards */}
        <div className="row mt-2">
          {casinoResult.casinoCardResultMaps.map((cardResult) => (
            <div
              key={cardResult.id}
              className={`col-md-${
                cardResult.resultFor === "Board" ? 12 : 6
              } text-center`}
            >
              <h4 className="result-title">{cardResult.resultFor}</h4>
              <div className="casino-result-cards">
                {cardResult.isWinning && (
                  <div className="casino-winner-icon">
                    <i className="fas fa-trophy" />
                  </div>
                )}
                {cardResult.result.map((card, index) => (
                  <img
                    key={index}
                    src={getCardImage(card)}
                    alt={`Card ${index}`}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Result Details */}
        <div className="row mt-2 justify-content-center">
          <div className="col-md-6">
            <div className="casino-result-desc">
              {casinoResult.casinoIndividualResultMaps.map((result) => (
                <div key={result.id} className="casino-result-desc-item">
                  <div>{result.resultFor}</div>
                  <div>{result.result[0]}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
